import { Button } from '@/components/ui/button'

const Footer = () => {
  return (
    <footer className="py-6">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-col items-center text-center space-y-1">
          <p className="font-geist text-sm text-emerald-800">
            © escarole {new Date().getFullYear()}. All rights reserved.
          </p>
          <a
            href="https://artisticworks.xyz"
            target="_blank"
            rel="noopener noreferrer"
            className="text-lime-600 hover:text-lime-800 transition-all duration-300 font-geist text-sm"
          >
            Built by <span className="font-bold">Artistic Works</span>
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
